export default "__VITE_ASSET__CZKJdWEm__"